"use strict";

var _interopRequireDefault = require("/Users/john/Desktop/Projects/nq-component/node_modules/@babel/runtime/helpers/interopRequireDefault.js")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("/Users/john/Desktop/Projects/nq-component/node_modules/@babel/runtime/helpers/esm/slicedToArray.js"));
var _react = _interopRequireDefault(require("react"));
var _classNames = _interopRequireDefault(require("../classNames"));
var _jsxFileName = "/Users/john/Desktop/Projects/nq-component/src/SelectSearch/index.js";
var noop = function noop() {};
var defaultProps = {
  loadOptions: noop,
  onChange: noop,
  onSearch: noop,
  onClickAdd: noop,
  onClickClear: noop,
  onFocus: noop,
  value: {
    label: "",
    value: ""
  },
  placeholder: "Select",
  dynamic: false
};
function SelectSearch(_ref) {
  var _this = this;
  var className = _ref.className,
    value = _ref.value,
    placeholder = _ref.placeholder,
    onChange = _ref.onChange,
    onSearch = _ref.onSearch,
    onClickAdd = _ref.onClickAdd,
    onClickClear = _ref.onClickClear,
    onFocus = _ref.onFocus,
    focus = _ref.focus,
    options = _ref.options,
    required = _ref.required,
    dynamic = _ref.dynamic,
    uppercase = _ref.uppercase,
    disabled = _ref.disabled;
  var _React$useState = _react["default"].useState(''),
    _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
    search = _React$useState2[0],
    setSearch = _React$useState2[1];
  var _React$useState3 = _react["default"].useState(''),
    _React$useState4 = (0, _slicedToArray2["default"])(_React$useState3, 2),
    text = _React$useState4[0],
    setText = _React$useState4[1];
  var _React$useState5 = _react["default"].useState(false),
    _React$useState6 = (0, _slicedToArray2["default"])(_React$useState5, 2),
    isOpen = _React$useState6[0],
    setOpen = _React$useState6[1];
  var ref = _react["default"].useRef(null);

  // handle click outside event
  var handleClickOutside = function handleClickOutside(event) {
    if (ref.current && !ref.current.contains(event.target)) {
      setOpen(false);
      onFocus(false);
    }
  };
  _react["default"].useEffect(function () {
    // add when mounted
    document.addEventListener("mousedown", handleClickOutside);
    // return function to be called when unmounted
    return function () {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  // when value change
  _react["default"].useEffect(function () {
    setText(value.label);
    setSearch("");
  }, [value]);
  function _onChange(e) {
    var value = e.target.value;
    // Get the new character input by the user by removing the previous text from the current value.
    var character = value.replace(text, '');
    if (search === "") {
      e.target.value = character;
    }
    if (uppercase) {
      e.target.value = value.toUpperCase();
    }
    // set the new character input by the user
    setSearch(e.target.value);
    setText(e.target.value);
    onSearch(e.target.value);
  }
  function onClick(e) {
    // e.target.setSelectionRange(0, 0);
    if (!isOpen) {
      e.target.blur();
    }
    setOpen(!isOpen || focus);
  }
  function onSelect(value, index) {
    onChange(value, index);
    setOpen(false);
    if (search) {
      // reset the options if has search
      onSearch('');
    }
  }
  function _onFocus(e) {
    if (!focus) {
      e.target.blur();
    }
    onFocus(true);
  }
  function onClickIcon(e) {
    if (text) {
      onClickClear(e);
    } else if (dynamic) {
      onClickAdd(e);
    } else {
      onClick(e);
    }
  }
  var style = {
    cursor: isOpen && focus ? 'text' : 'default'
  };
  var icon = text ? "bi bi-x" : dynamic ? "bi bi-plus" : "bi bi-chevron-down";
  var sort = function sort(a, b) {
    // Check if 'a' contains 'd' and 'b' does not
    var aContainsInput = (a.label || a.name).includes(search);
    var bContainsInput = (b.label || a.name).includes(search);
    if (aContainsInput && !bContainsInput) {
      return -1; // Move 'a' before 'b'
    } else if (!aContainsInput && bContainsInput) {
      return 1; // Move 'b' before 'a'
    } else {
      return 0; // Keep original order if both contain 'd' or neither does
    }
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    ref: ref,
    style: {
      position: 'relative'
    },
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 128,
      columnNumber: 9
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "input-group",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 131,
      columnNumber: 13
    }
  }, /*#__PURE__*/_react["default"].createElement("input", {
    onClick: onClick,
    type: "text",
    className: (0, _classNames["default"])(className, "form-control border-end-0 pe-0"),
    placeholder: placeholder,
    value: text,
    onChange: _onChange,
    onFocus: _onFocus,
    style: style,
    required: required,
    disabled: disabled,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 132,
      columnNumber: 17
    }
  }), /*#__PURE__*/_react["default"].createElement("button", {
    onClick: onClickIcon,
    className: "btn btn-link",
    type: "button",
    disabled: disabled,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 144,
      columnNumber: 17
    }
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: icon,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 149,
      columnNumber: 21
    }
  }))), isOpen && /*#__PURE__*/_react["default"].createElement("ul", {
    className: "list-group rounded-0 bg-white",
    style: {
      position: 'absolute',
      top: '100%',
      width: '100%',
      maxHeight: '200px',
      overflowY: 'auto',
      zIndex: 1000
    },
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 154,
      columnNumber: 17
    }
  }, options.sort(sort).map(function (option, index) {
    return /*#__PURE__*/_react["default"].createElement("li", {
      key: option.value,
      type: "button",
      className: "list-group-item list-group-item-action",
      onClick: function onClick() {
        return onSelect(option, index);
      },
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 165,
        columnNumber: 29
      }
    }, option.label || option.name);
  })));
}
SelectSearch.defaultProps = defaultProps;
var _default = exports["default"] = SelectSearch;